import { createAction } from '@lingoda/core';
import type { Credit } from '../models';

export default createAction<Credit[]>('store/ADD_CREDITS');
